module.exports = __webpack_public_path__ + "img/bosnia-and-herzegovina.ccb86f0e.png";